import React, { useEffect } from "react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import "./scss/styles.scss";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";
import { fetchUser } from "./redux/actions/userActions";
import { fetchCustomer } from "./redux/actions/customerActions";
import { fetchSettings } from "./redux/actions/learningCenterSettingsActions";
import GoogleMapWrapper from "./components/GoogleMap/GoogleMapWrapper";
import useCustomerColors from "./hooks/useCustomerColors";
import { fetchUserProfile } from "./redux/actions/userProfileActions";
import { usePendo } from "./hooks/usePendo";

const initializeGoogleAnalytics = () => {
  if (
    process.env.REACT_APP_ENVIRONMENT &&
    process.env.REACT_APP_ENVIRONMENT === "production"
  ) {
    ReactGA.initialize([
      {
        trackingId: "G-SLNB2V93F1"
      }
    ]);
    ReactGA.send({
      hitType: "pageview",
      page: `/${window.location.pathname + window.location.search}`
    });
    console.log(window.location.pathname + window.location.search);
  } else if (process.env.REACT_APP_ENVIRONMENT?.includes("dev")) {
    ReactGA.initialize([
      {
        trackingId: "G-VXM00WMGSK"
      }
    ]);
    ReactGA.send({
      hitType: "pageview",
      page: `/${window.location.pathname + window.location.search}`,
      title: "Testing Title"
    });
    console.log(window.location.pathname + window.location.search);
  } else {
    console.log("Environment", process.env.REACT_APP_ENVIRONMENT);
  }
};

const App = ({ hideLoader, children }) => {
  const dispatch = useDispatch();
  const { primaryColor, secondaryColor } = useCustomerColors();
  useEffect(() => {
    initializeGoogleAnalytics();
    dispatch(fetchUser());
    dispatch(fetchCustomer());
    dispatch(fetchSettings());
    dispatch(fetchUserProfile());
    hideLoader && hideLoader();
  }, []);

  usePendo();

  return (
    <GoogleMapWrapper>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme(primaryColor, secondaryColor)}>
          <DndProvider backend={HTML5Backend}>{children}</DndProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </GoogleMapWrapper>
  );
};

export default App;
